import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSpaceMembersKey } from '../../utils/keys';
export const useUpdateMemberSpaceRole = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(input => client.spaceRoles.updateMemberRole(input), {
        onSettled: (data, error, variables) => {
            const spaceMembersKey = getSpaceMembersKey({
                variables: {
                    spaceId: variables.spaceId,
                },
            });
            queryClient.invalidateQueries(spaceMembersKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateMemberSpaceRole.js.map